<template>
  <div class="mv-bg-main" style="overflow: scroll;">
    <el-card class="mr">
      <el-row>
        <el-col :span="6">
          <div class="task">
            <p class="center_task">我的待办</p>
            <p class="center_task" style="color: #7FFFAA;">{{todoList}}</p>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="task">
            <p class="center_task">本周任务平均处理时长(分钟)</p>
            <p class="center_task" style="color: #FFA500;">{{handleTime}}</p>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="task">
            <p class="center_task">进行中任务数</p>
            <p class="center_task" style="color: #FFD700;">{{taskNumber}}</p>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="task">
            <p class="center_task">本周完成任务数</p>
            <p class="center_task" style="color: #F4606C;">{{completeTask}}</p>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="mr">
      <div slot="header" class="clearfix">
        <span>查询条件</span>
      </div>
      <el-form :inline="true" ref="searchForm" :model="form" class="demo-form-inline ">
        <el-form-item label="任务名称" >
          <el-input style="width: 217px;" clearable placeholder="请输入任务名称" v-model="form.taskName"  auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="当前操作人" >
          <el-select @clear="clearMatch" :filter-method="filterPinYinMethod" v-model="form.operName" filterable clearable  placeholder="请选择当前操作人">
            <el-option v-for="(item, $index) in person"  :key="$index" :label="item.accountName" :value="item.userId" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务日期" >
          <el-date-picker
            v-model="form.date"
            :editable = "editable"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="任务状态" >
          <el-select v-model="form.state"  clearable  placeholder="请选择任务状态">
            <el-option label="待办" value="1" ></el-option>
            <el-option label="进行中" value="2" ></el-option>
            <el-option label="已完成" value="3" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="float-r">
          <el-button size="small" @click="onReset('searchForm')">重置</el-button>
          <el-button size="small" type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="mr">
      <div slot="header" class="clearfix">
        <span class="card-title">查询结果</span>
        <el-button type="primary" size="small" style="float: right; margin-top: -10px; margin-right: 10px;" @click="handleAdd" icon="el-icon-plus"></el-button>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column
          label="任务编号"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span class="link" @click="detail(scope.$index, scope.row)">{{ scope.row.taskId }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="任务名称"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.taskName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="当前操作人"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.handlerName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="任务状态"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.status | status }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="开始时间"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="执行进度"
          width="">
          <template slot-scope="scope">
            <el-progress :percentage="scope.row.status | progress"></el-progress>
          </template>
        </el-table-column> -->
        <el-table-column
          label="操作"
          fixed="right"
          width="300">
          <template slot-scope="scope">
            <el-button size="mini" :disabled="((scope.row.status === 2) ? true: false) || ((scope.row.status === 3) ? true: false)" @click="handle(scope.$index, scope.row)" >处理</el-button>
            <el-button size="mini" :disabled="scope.row.status === 3 ? true: false" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" :disabled="((scope.row.status === 1) ? true: false) || ((scope.row.status === 3) ? true: false)"  @click="urge(scope.$index, scope.row)" >催办</el-button>
            <el-button size="mini" @click="delTask(scope.$index, scope.row)" >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt center"
        background
        @size-change="handleSizeChange"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="page"
        layout="total, sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-card>
    <el-dialog @close="closeTask" :title="taskTitle"  width="450px" center :modal-append-to-body='false' :visible.sync="taskDialog">
      <el-form :model="taskInfo" :rules="taskRule" ref="taskInfo" label-width="130px">
          <el-form-item label="任务名称:" prop="taskName" :required="required"  >
            <el-input style="width: 217px;" :disabled="!add"  maxlength="30" clearable v-model="taskInfo.taskName" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="期望完成时间:" prop="date"  :required="required" >
            <el-date-picker
            type="datetime"
            :picker-options="pickerBeginDateBefore"
            v-model="taskInfo.date"
            placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss" >
          </el-date-picker>
          </el-form-item>
          <el-form-item label="下一节点责任人:"  prop="state" :required="required" >
            <el-select @clear="clearAddMatch" :filter-method="filterPinYinAddMethod"  clearable filterable v-model="taskInfo.state" :disabled="!add"  placeholder="请选择下一节点责任人">
              <el-option v-for="(item, $index) in addPerson"  :key="$index" :label="item.accountName" :value="item.userId" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="任务描述:"   >
            <el-input type="textarea" style="width: 217px;" maxlength="255" v-model="taskInfo.desc"></el-input>
          </el-form-item>
          <div style="textAlign: center;">
            <el-button @click="taskDialog=false">取 消</el-button>
            <el-button type="primary" v-show="add" @click="addSave('taskInfo')">确 定</el-button>
            <el-button type="primary" v-show="!add" @click="editSave('taskInfo')">确 定</el-button>
          </div>
        </el-form>
    </el-dialog>
    <el-dialog @close="closeHandleTask" title="任务处理"  width="850px" center :modal-append-to-body='false' :visible.sync="handleDialog">
      <el-form :model="handleInfo" :rules="handleRule" ref="handleInfo" label-width="130px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="任务编号:"    >
              <el-input style="width: 217px;" disabled  maxlength="30" clearable v-model="handleInfo.taskId" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="任务名称:"   >
              <el-input style="width: 217px;" disabled  maxlength="30" clearable v-model="handleInfo.taskName" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="任务状态:"    >
              <el-select v-model="handleInfo.state" disabled clearable  placeholder="请选择任务状态">
                <el-option label="待办" value="1" ></el-option>
                <el-option label="进行中" value="2" ></el-option>
                <el-option label="已完成" value="3" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="处理意见:"   >
              <el-input type="textarea" maxlength="255" v-model="handleInfo.handleDesc"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="任务来源:"    >
              <el-input style="width: 217px;" disabled  maxlength="30" clearable v-model="handleInfo.source" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="任务创建时间:"    >
              <el-input style="width: 217px;" disabled  maxlength="30" clearable v-model="handleInfo.createDate" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="期望完成时间:"    >
              <el-input style="width: 217px;" disabled  maxlength="30" clearable v-model="handleInfo.expectEndTime" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="任务描述:"   >
              <el-input type="textarea" maxlength="255" v-model="handleInfo.desc"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
         <el-form-item label="任务处理结果:">
          <el-radio-group  v-model="handleInfo.resourceType">
            <el-radio value="0" label="0">下一步</el-radio>
            <el-radio value="1" label="1">完成</el-radio>
            <el-radio value="2" label="2">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="下一节点责任人:" v-if="handleInfo.resourceType === '0' ? true : false" prop="person" :required="required" >
          <el-select @clear="clearHandleMatch" :filter-method="filterPinYinHandleMethod" clearable  filterable v-model="handleInfo.person"   placeholder="请选择下一节点责任人">
            <el-option v-for="(item, $index) in handlePerson"  :key="$index" :label="item.accountName" :value="item.userId" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="textAlign: center;">
          <el-button @click="handleDialog=false">取 消</el-button>
          <el-button type="primary"  @click="addHandleSave('handleInfo')">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog @close="closeDetail"  title="任务详情"  width="850px" center :modal-append-to-body='false' :visible.sync="detailDialog">
      <el-form :model="detailInfo" :rules="handleRule" ref="handleInfo" label-width="130px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="任务编号:"    >
              <el-input style="width: 217px;" disabled  maxlength="30" clearable v-model="detailInfo.taskId" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="任务名称:"   >
              <el-input style="width: 217px;" disabled  maxlength="30" clearable v-model="detailInfo.taskName" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="任务状态:"    >
              <el-select v-model="detailInfo.state" disabled clearable  placeholder="请选择任务状态">
                <el-option label="待办" value="1" ></el-option>
                <el-option label="进行中" value="2" ></el-option>
                <el-option label="已完成" value="3" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="任务描述:"   >
              <el-input type="textarea" disabled v-model="detailInfo.desc"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="任务来源:"    >
              <el-input style="width: 217px;" disabled  maxlength="30" clearable v-model="detailInfo.source" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="任务创建时间:"    >
              <el-input style="width: 217px;" disabled  maxlength="30" clearable v-model="detailInfo.createDate" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="期望完成时间:"    >
              <el-input style="width: 217px;" disabled  maxlength="30" clearable v-model="detailInfo.expectEndTime" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div style="margin-left: 56px;">
          <el-steps direction="vertical" :active="active" align-center>
            <el-step :title="item.operateType | stepDesc" :description="item.creator + '   提交于   ' + item.createTime + '   执行责任人   ' + item.handler + '   处理意见   ' + item.remark" v-for="(item, index) in step" :key="index"></el-step>
          </el-steps>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
@import "../../assets/sass/base.scss";
.mr {
  margin: 10px;
}
.task {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  height: 80px;
}
.center_task {
  flex: 1;
  font-size: 16px;
  text-align: center;
}
.float {
  float: left;
}
</style>
<script>
import 'v-charts/lib/style.css'
export default {
  name: 'homePage',
  data () {
    return {
      form: {
        taskName: '',
        operName: '',
        date: '',
        state: ''
      },
      pickerBeginDateBefore: {
        disabledDate (time) {
          let yestoday = new Date()
          yestoday.setDate(yestoday.getDate() - 1)
          return time.getTime() < yestoday.getTime()
        }
      },
      person: [],
      step: [],
      active: '',
      todoList: '',
      handleTime: '',
      taskNumber: '',
      completeTask: '',
      add: false,
      taskInfo: {
        taskName: '',
        date: '',
        flowId: '',
        state: '',
        desc: ''
      },
      handleInfo: {
        taskId: '',
        taskName: '',
        source: '',
        flowId: '',
        status: '',
        createDate: '',
        handleDesc: '',
        expectEndTime: '',
        desc: '',
        person: '',
        resourceType: ''
      },
      detailInfo: {
        taskId: '',
        taskName: '',
        source: '',
        flowId: '',
        status: '',
        createDate: '',
        handleDesc: '',
        expectEndTime: '',
        desc: ''
      },
      detailDialog: false,
      handleRule: {
        person: [
          { required: true, message: '请选择下一节点责任人', trigger: ['blur', 'change'] }
        ]
      },
      taskDialog: false,
      handleDialog: false,
      taskTitle: '',
      taskRule: {
        date: [
          { required: true, message: '期望完成时间不能为空', trigger: ['blur'] }
        ],
        taskName: [
          { required: true, message: '请输入任务名称', trigger: ['blur', 'change'] },
          {
            validator: (rule, value, callback) => {
              if (value !== '') {
                if ((/(^\s+)|(\s+$)/).test(value)) {
                  callback(new Error('输入前后不能为空格'))
                } else {
                  callback()
                }
              } else {
                callback(new Error('任务名称不能为空'))
              }
            },
            trigger: ['blur', 'change'],
            required: true
          },
          { min: 1, max: 30, message: '长度在1至30个字符', trigger: ['blur', 'change'] }
        ],
        state: [
          { required: true, message: '请选择下一节点责任人', trigger: ['blur', 'change'] }
        ]
      },
      required: true,
      total: 0,
      currentPage: 1,
      page: 10,
      tooltip: true,
      editable: false,
      operList: [],
      addPerson: [],
      handlePerson: [],
      addCopeList: [],
      handleCopeList: [],
      tableData: []
    }
  },
  filters: {
    progress (val) { // 状态转化
      let status = ''
      if (val === 1) {
        status = 0
      } else if (val === 2) {
        status = 50
      } else {
        status = 100
      }
      return status
    },
    stepDesc (val) {
      let status = ''
      if (val === '0') {
        status = '创建任务'
      } else if (val === '1') {
        status = '转发任务'
      } else {
        status = '完成任务'
      }
      return status
    },
    status (val) { // 状态转化
      let status = ''
      if (val === 1) {
        status = '待办'
      } else if (val === 2) {
        status = '进行中'
      } else {
        status = '已完成'
      }
      return status
    }
  },
  created () {
    /* 查询责任人 */
    // let _this = this
    this.$axios({
      url: this.$API.home.queryHandlerList,
      method: 'post',
      data: {flag: true}
    }).then((response) => {
      let data = response.data.resData
      this.person = data
      this.operList = data
    }).catch((err) => {
      console.log(err)
    })
    this.$axios({
      url: this.$API.home.queryHandlerList,
      method: 'post',
      data: {flag: false}
    }).then((response) => {
      let data = response.data.resData
      this.addPerson = data
      this.handlePerson = data
      this.addCopeList = data
      this.handleCopeList = data
      console.log(data)
    }).catch((err) => {
      console.log(err)
    })
    this.queryTask()
    this.query()
  },
  methods: {
    handleSizeChange (val) {
      this.page = val
      this.currentPage = 1
      this.query()
    },
    onSubmit () {
      this.currentPage = 1
      this.query()
    },
    clearMatch () {
      this.person = this.operList
    },
    filterPinYinMethod (val) {
      const pinyinMatch = require('pinyin-match')
      if (val) {
        let result = []
        this.operList.forEach((v) => {
          let m = pinyinMatch.match(v.accountName, val)
          if (m) {
            result.push(v)
          }
        })
        this.person = result
      } else {
        this.person = this.operList
      }
      this.form.operName = val
    },
    clearAddMatch () {
      this.addPerson = this.addCopeList
    },
    clearHandleMatch () {
      this.handlePerson = this.handleCopeList
    },
    filterPinYinAddMethod (val) {
      const pinyinMatch = require('pinyin-match')
      if (val) {
        let result = []
        this.addCopeList.forEach((v) => {
          let m = pinyinMatch.match(v.accountName, val)
          if (m) {
            result.push(v)
          }
        })
        this.addPerson = result
      } else {
        this.addPerson = this.addCopeList
      }
      this.taskInfo.state = val
    },
    filterPinYinHandleMethod (val) {
      const pinyinMatch = require('pinyin-match')
      if (val) {
        let result = []
        this.handleCopeList.forEach((v) => {
          let m = pinyinMatch.match(v.accountName, val)
          if (m) {
            result.push(v)
          }
        })
        this.handlePerson = result
      } else {
        this.handlePerson = this.handleCopeList
      }
      this.handleInfo.person = val
    },
    onReset () {
      this.form = {
        taskName: '',
        operName: '',
        date: '',
        state: ''
      }
      this.person = this.operList
    },
    handleAdd () {
      this.taskTitle = '任务维护'
      this.add = true
      this.taskDialog = true
    },
    format (val) { // 时间戳转化
      function add0 (m) { return m < 10 ? '0' + m : m }
      var time = new Date(val)
      var y = time.getFullYear()
      var m = time.getMonth() + 1
      var d = time.getDate()
      var h = time.getHours()
      var mm = time.getMinutes()
      var s = time.getSeconds()
      return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm) + ':' + add0(s)
    },
    detail (index, row) {
      this.detailInfo.taskId = row.taskId
      this.detailInfo.flowId = row.flowId
      this.detailInfo.taskName = row.taskName
      this.detailInfo.source = row.source === '1' ? '手动创建' : '系统创建'
      this.detailInfo.state = row.status + ''
      this.detailInfo.createDate = row.createTime
      this.detailInfo.desc = row.description
      this.detailInfo.expectEndTime = row.expectCompTime
      let op = {}
      op.taskId = row.taskId
      let _this = this
      this.$axios({
        url: this.$API.home.queryWorkTaskById,
        method: 'post',
        data: op
      }).then((response) => {
        console.log(response.data)
        let data = response.data.resData
        this.step = data
        data.forEach((v, i) => {
          if (v.checked) {
            _this.active = Number(i) + 1
          }
        })
        console.log(_this.active)
        this.detailDialog = true
      }).catch((err) => {
        console.log(err)
      })
    },
    handleEdit (index, row) {
      this.taskTitle = '编辑任务维护'
      this.add = false
      this.taskInfo.taskName = row.taskName
      this.taskInfo.date = row.expectCompTime
      this.taskInfo.flowId = row.flowId
      this.taskInfo.desc = row.description
      this.taskInfo.state = row.handlerId
      this.taskDialog = true
    },
    handle (index, row) {
      this.handleInfo.taskId = row.taskId
      this.handleInfo.flowId = row.flowId
      this.handleInfo.taskName = row.taskName
      this.handleInfo.source = row.source === '1' ? '手动创建' : '系统创建'
      this.handleInfo.state = row.status + ''
      this.handleInfo.createDate = row.createTime
      // this.handleInfo.handleDesc = row.handleDesc
      this.handleInfo.expectEndTime = row.expectCompTime
      // this.handleInfo.person = row.person
      // this.handleInfo.desc = row.remark
      // this.handleInfo.resourceType = row.resourceType
      this.handleDialog = true
    },
    addSave (formName) { // 新增任务
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let op = {}
          op.taskName = _this.taskInfo.taskName
          op.expectCompTime = _this.taskInfo.date
          op.description = _this.taskInfo.desc
          op.handler_id = _this.taskInfo.state
          op.source = '1'
          _this.$axios({
            url: _this.$API.home.createWorkTask,
            method: 'post',
            data: op
          }).then((response) => {
            _this.queryTask()
            _this.query()
            _this.$message.success('任务新增成功!')
            _this.taskDialog = false
          }).catch((err) => {
            console.log(err)
          })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    editSave (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let op = {}
          op.expectCompTime = _this.taskInfo.date
          op.description = _this.taskInfo.desc
          op.handler_id = _this.taskInfo.state
          op.flowId = _this.taskInfo.flowId
          _this.$axios({
            url: _this.$API.home.updateWorkTask,
            method: 'post',
            data: op
          }).then((response) => {
            _this.query()
            _this.$message.success('任务编辑成功!')
            _this.taskDialog = false
          }).catch((err) => {
            console.log(err)
          })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    addHandleSave (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let op = {}
          op.flowId = _this.handleInfo.flowId
          op.handlerResult = _this.handleInfo.resourceType
          op.description = _this.handleInfo.desc
          op.handlerId = _this.handleInfo.person
          op.remark = _this.handleInfo.handleDesc
          _this.$axios({
            url: _this.$API.home.handleWorkTask,
            method: 'post',
            data: op
          }).then((response) => {
            _this.query()
            _this.$message.success('任务处理成功!')
            _this.handleDialog = false
          }).catch((err) => {
            console.log(err)
          })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.query()
    },
    urge (index, val) {
      let op = {}
      let _this = this
      op.flowId = val.flowId
      this.$confirm('是否催办任务? 催办只能催办待办和进行中的任务。', '催办任务', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios({
          method: 'post',
          // url: _this.$API.supplier.deleteSupServiceInfo,
          url: _this.$API.home.remindWorkTask,
          data: op
        }).then((response) => {
          _this.query()
          _this.$message.success('催办成功!')
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    delTask (index, row) {
      let op = {}
      let _this = this
      op.flowId = row.flowId
      this.$confirm('是否确认删除任务？只能删除完成或者创待办状态的任务，已经处理的任务不可删除', '是否确认删除任务', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios({
          method: 'post',
          url: _this.$API.home.deleteWorkTask,
          data: op
        }).then((response) => {
          _this.query()
          _this.queryTask()
          _this.$message.success('删除成功!')
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    closeHandleTask () {
      this.handleInfo = {
        taskId: '',
        taskName: '',
        source: '',
        flowId: '',
        status: '',
        createDate: '',
        handleDesc: '',
        expectEndTime: '',
        desc: '',
        person: '',
        resourceType: ''
      }
      this.handlePerson = this.handleCopeList
      this.handleDialog = false
      this.$refs['handleInfo'].resetFields() // 关闭时清除验证条件
    },
    closeDetail () {
      this.detailInfo = {
        taskId: '',
        taskName: '',
        source: '',
        flowId: '',
        status: '',
        createDate: '',
        handleDesc: '',
        expectEndTime: '',
        desc: ''
      }
      this.active = 0
      this.step = []
      this.detailDialog = false
    },
    closeTask () {
      this.taskTitle = '任务维护'
      this.add = false
      this.taskDialog = false
      this.addPerson = this.addCopeList
      this.taskInfo = {
        taskName: '',
        date: '',
        flowId: '',
        status: '',
        desc: ''
      }
      this.$refs['taskInfo'].resetFields() // 关闭时清除验证条件
    },
    /* 查询任务处理详情 */
    queryTask () {
      let _this = this
      this.$axios({
        url: _this.$API.home.queryWorkProcessDetail,
        method: 'get'
      }).then((response) => {
        let data = response.data.resData
        _this.todoList = data.todoSize
        _this.handleTime = data.avgProcessTime
        _this.taskNumber = data.processingTaskSize
        _this.completeTask = data.completedTaskSizeWeekly
      }).catch((err) => {
        console.log(err)
      })
    },
    /* 分页查询 */
    query () {
      let op = {}
      let _this = this
      op.taskName = this.form.taskName
      op.status = this.form.state
      op.createStartTime = this.form.date ? this.form.date[0] : ''
      op.createEndTime = this.form.date ? this.form.date[1] : ''
      op.handler_id = this.form.operName
      op.pageNum = this.currentPage
      op.pageSize = this.page
      this.$axios({
        url: _this.$API.home.queryWorkTaskByPage,
        method: 'post',
        data: op
      }).then((response) => {
        let data = response.data.resData.resultList
        _this.tableData = data
        _this.total = response.data.resData.total
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/home/homePage.vue